// src/pages/hotelRoomCategories/CreateHotelRoomCategory.jsx

import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import FormAddEditHotelRoomCategory from "../../components/hotelRoomCategories/FormAddEditHotelRoomCategory";
import { useNavigate } from "react-router-dom";

const CreateHotelRoomCategory = () => {
    const navigate = useNavigate();

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditHotelRoomCategory
                isEdit={false}
                onSubmitSuccess={() => navigate("/hotel-room-categories")}
            />
        </WrapperSection>
    );
};

export default CreateHotelRoomCategory;
